import React, { useState } from 'react';

import FeedbackModal from 'components/Shared/Feedback/FeedbackModal/FeedbackModal';
import SendMerchantMessageModal from 'components/Shared/SendMerchantMessage/SendMerchantMessageModal';
import { colors, fontSize } from 'styles/cp';

interface AiAssistChatActionsProps {
  actionList?: string[];
  companyName?: string;
  merchantEmail?: string;
  customerEmail?: string;
}

export const AiAssistChatActions: React.FC<AiAssistChatActionsProps> = ({
  actionList,
  companyName,
  merchantEmail,
  customerEmail,
}) => {
  const [showFeedbackSurvey, setShowFeedbackSurvey] = useState(false);

  if (!actionList?.length) return null;

  return (
    <div className="system-message-wrapper">
      {actionList.includes('Send_Email_To_Merchant') && (
        <SendMerchantMessageModal
          companyName={companyName ?? ''}
          merchantEmail={merchantEmail ?? ''}
          customerEmail={customerEmail ?? ''}
          trigger={(open) => (
            <button onClick={open} className="cp-chat-merchant-button">
              Send message to the business
            </button>
          )}
        />
      )}
      {actionList.includes('Leave_Feedback') && (
        <button
          className="cp-chat-merchant-button"
          onClick={() => {
            setShowFeedbackSurvey(true);
          }}
        >
          Leave Feedback
        </button>
      )}
      {showFeedbackSurvey && (
        <FeedbackModal
          onHide={() => {
            setShowFeedbackSurvey(false);
          }}
        />
      )}
      <style jsx>{`
        .system-message-wrapper {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }
        .cp-chat-merchant-button {
          color: ${colors.green05};
          border: 2px solid ${colors.green05};
          border-radius: 9999px;
          padding: 12px 16px;
          font-size: ${fontSize.xs};
          font-family: inherit;
          cursor: pointer;
          outline: none;
          transition: background 0.2s, color 0.2s, border 0.2s;
          display: inline-block;
          background: ${colors.white};
          width: fit-content;
        }
      `}</style>
    </div>
  );
};
